const initialState = {
  loading: false,
  groups: [],
  groupByEvent: [],
  selectedGroup: {},
};

const groupsReducer = (state = initialState, actions) => {
  switch (actions.type) {
    case "GET_GROUPS_DATA": {
      return {
        ...state,
        loading: actions.loading,
        groups: actions.data,
      };
    }
    case "LOADING_GROUP": {
      return { ...state, loading: actions.loading };
    }
    case "UPDATE_GROUP": {
      return { ...state, groups: actions.data };
    }
    case "GET_GROUPS_BY_EVENT": {
      return { ...state, groupByEvent: actions.data, loading: actions.loading };
    }
    case "SET_SELECTED_GROUP": {
      return { ...state, selectedGroup: actions.data };
    }
    case "CLEAR_GROUP": {
      return { ...state, selectedGroup: {} };
    }
    case "CLEAR_GROUP_DATA": {
      return { ...state, groupByEvent: [] };
    }
    default:
      return state;
  }
};
export default groupsReducer;
